import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchpassengers'
})
export class SearchpassengersPipe implements PipeTransform {

  transform(list: any, ...args: any[]): any {
    const filterText = args[0];
    if (!filterText) {
      return list;
    }
    return list ? list.filter(item => (item.firstName && item.firstName.search(new RegExp(filterText, 'i')) > -1
    )):[];
  }

}
